export const JASPER_REPORT_SLICE = 'JASPER_REPORT_SLICE';
